import SerifAndSansSerifHeadline from '@/components/_rebrand/craft/product/_organisms/SerifAndSansSerifHeadline';
import ProductTemplateHero, { ProductTemplateHeroProps } from '@/components/_rebrand/heroes/ProductTemplateHero';
import { mapBackgroundColor } from '@/helpers/mapBackgroundColor';

const displayProps = {
  eyebrow: '',
  title: '',
  description: '',
  media: null,
  links: [
    {
      type: 'primary',
      title: 'Request a demo',
      href: '',
      action: 'demo',
    },
    {
      type: 'secondary',
      title: 'Try for free',
      href: '',
      action: 'trial',
    },
  ],
  featuredImage: {
    desktop: {
      url: 'https://front.com/webassets/rebrand/ticketing-hero.png',
      width: 505,
      height: 612,
      alt: 'Ticketing'
    },
    mobile: {
      url: 'https://front.com/webassets/rebrand/ticketing-hero-mobile.svg',
      width: 298,
      height: 256,
      alt: 'Ticketing'
    },
  },
  decorationImageUrl: '',
} as ProductTemplateHeroProps;

interface AssetImageFromCraft {
  url: string;
  title: string;
  alt: string;
  width: number;
  height: number;
}

const makeImageProps = (desktopAttributes: AssetImageFromCraft, mobileAttributes: AssetImageFromCraft) => {
  return {
    desktop: {
      url: desktopAttributes.url ?? 'https://front.com/webassets/rebrand/ticketing-hero.png',
      width: desktopAttributes.width ?? 505,
      height: desktopAttributes.height ?? 612,
      alt: desktopAttributes.alt ?? 'Ticketing'
    },
    mobile: {
      url: mobileAttributes.url ?? 'https://front.com/webassets/rebrand/ticketing-hero-mobile.svg',
      width: mobileAttributes.width ?? 298,
      height: mobileAttributes.height ?? 256,
      alt: mobileAttributes.alt ?? 'Ticketing'
    },

  }
}

const setDynamicDisplayPropAttributes = (entry: any) => {
  const heroData = Array.isArray(entry?.moduleProductPageHero)
    ? entry.moduleProductPageHero[0]
    : entry?.moduleProductPageHero;

  displayProps.title = <SerifAndSansSerifHeadline {...heroData.header[0]} />
  displayProps.eyebrow = heroData?.eyebrowText;
  displayProps.description = heroData?.description;
  displayProps.featuredImage = makeImageProps(heroData.supportingImage[0], heroData.mobileSupportingImage[0]);
  displayProps.decorationImageUrl = heroData.backgroundPattern[0]?.url ?? 'https://front.com/webassets/rebrand/ticketing-pattern-background.svg';
  displayProps.backgroundColor = mapBackgroundColor(entry.moduleProductTheme[0].color);
}

const Hero = ({ entry }) => {
  setDynamicDisplayPropAttributes(entry);

  return (
    <ProductTemplateHero {...displayProps} />
  );
};

export default Hero;
